
//TODO: image deletion
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="75vw"
    center
    fullscreen
  >
    <div>
      <div>
        <div class="u-center-text u-margin-bottom-big">
          <h2 class="heading-secondary">
            Image Viewer
          </h2>
        </div>

        <div class="modal-body">
          <slot name="body">
            <div v-if="dataLoaded">
              <div
                v-for="(imageChunk, index) in imageChunks"
                :key="index"
                class="row"
              >
                <div
                  v-for="(image, imageIndex) in imageChunk"
                  :key="imageIndex"
                  class="column"
                >
                  <img :src="image">
                  <div class="column__title">
                    {{ resolvedFileName(image) }}
                  </div>

                  <div class="column__actions">
                    <a
                      class="btn-tiled quaternary"
                      @click="selectImage(imageIndex, index)"
                    >
                      Select
                    </a>
                    <!-- <a
                          class="btn-tiled tertiary"    
                          @click="deleteImage(imageIndex, index)"
                        >
                          Delete
                        </a> -->
                    <a
                      href="#popupimage"
                      class="btn-tiled tertiary"
                      @click="imageInfo(imageIndex, index)"
                    >Info</a>
                  </div>
                </div>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <button
        class="btn-tiled tertiary"
        style="margin-right: 1rem;"
        @click="closeGallery"
      >
        Close
      </button>
    </span>
  </el-dialog>
</template>

<script>
// TODO keep all axios requests in a folder
import { EventBus } from '@/eventbus/event-bus';

import _ from 'lodash'
import axios from 'axios'
export default {
  data: function () {
    
    return {
      images: null,
      rowLength: 4,
      dataLoaded: false,
      dialogVisible: true,
    }
  },
  computed: {
    imageChunks () {
      return _.chunk(Object.values(this.images), this.rowLength)
    }
  },
  mounted () {
    axios.get('https://us-central1-skypet-9792e.cloudfunctions.net/getImagesFromBucketByResolution?bucket=skypet_blog_images&resolution=720')
      .then((response) => {
        this.images = response.data
        this.dataLoaded = true
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  methods: {
    resolvedFileName(path)  {
      var filename = path.replace(/^.*[\\\/]/, '')
      filename = filename.replace('@s_720', '')
      var extension = path.split('.').pop();
      return filename
    },
    closeGallery () {
      console.log('close the gallery')
      this.$emit('closeGallery')
    },
    selectImage (imageIndex, index) {
      const resolvedIndex = (index * this.rowLength) + imageIndex
     
      this.$emit('imageUrl', this.images[resolvedIndex])
      this.closeGallery()
    },
    imageInfo (imageIndex, index) {
      const resolvedIndex = (index * this.rowLength) + imageIndex
      EventBus.$emit('popupImageSelected', this.images[resolvedIndex]);
    }
  }
}
</script>

